<template>
  <div v-if="list">
    <h3> {{list.title}}</h3>
    <div style="margin-top: 15px;" v-if="displayBiblioPreview === true">
      <h4>Biblio</h4>
      <template v-if="list.biblio[0].content !== '{}' || list.biblio[0].content == null">
        <biblio-go-j-s ref="biblio" id="biblioGoJS"
                       style="width:100%; height:100%"
                       :content="list.biblio[0].content"
        />
        <img style="width: 100%" ref="biblioImg"/>
      </template>
    </div>
    <div class="clearfix" v-if="displayBiblioContent === true">
      <h4>Biblio Content</h4>
      <biblio-tree :nodes="biblioNodes" :depth="0" :print="false" :ref-depth="{}"/>

      <div v-if="!$user.isOrange() && !$user.isSe()">
        <h4 style="margin-top: 15px">Technological / Scientific problems extracted from the Biblio</h4>
        <div v-for="(technoLockIn, key) in aichat" :key="key">
          <div style="margin: 5px 0" v-html="technoLockIn"></div>
        </div>
      </div>

      <h4 style="margin-top: 15px">Bibliography</h4>
        <div v-for="(cite, key) in bibliography" :key="key">
         <div style="margin: 5px 0">{{cite}}</div>
        </div>
    </div>

    <div class="clearfix" v-if="authorsSelected.length !== 0 && displayExpertsCompanies === true">

      <div style="margin-top: 15px">
        <h4>Experts</h4>

        <div style="margin-left: 15px">
          <div v-for="(author, key) in authorsSelected" :key="key" class="border-top" style="padding: 15px 0">
            <div class="text-info" style="font-size: 18px">{{author.lastName}} {{author.firstName}}</div>

            <div v-if="author.docs.length === 0">
              <div style="margin-left:15px;margin-top: 15px">
                <label>Experts added manually</label>
              </div>

            </div>
            <template v-else>

              <template v-if="author.affiliation">
              <div class="row" style="margin-left:15px;margin-top: 15px">
                <div class="col-sm-12">
                  <label class="col-sm-2">Affiliation</label>
                  <span class="col-sm-10">
                    <span v-if="author.affiliation.organisationName">{{author.affiliation.organisationName}}</span>
                    <span v-if="author.affiliation.city">, {{author.affiliation.city}}</span>
                    <span v-if="author.affiliation.country">, {{author.affiliation.country}}</span>
                  </span>
                </div>
              </div>
              </template>

              <div style="margin-left:15px;margin-top: 15px">
                <label>Documents</label>
              </div>

              <div v-if="author.docs.length !== 0" v-for="(document, documentKey) in author.docs" :key="documentKey" class="row" style="margin-left:15px;margin-top: 15px">
                <div class="col-sm-12">
                  <label class="col-sm-2">Title</label>
                  <span class="col-sm-10" v-html="document.title"></span>
                </div>
                <div class="col-sm-12">
                  <label class="col-sm-2">Authors</label>
                  <div class="col-sm-10">
                    <span class="coAuthors-divider" v-for="(coAuthor, key) in document.co_authors" v-bind:key="key">{{ coAuthor.lastName }} {{coAuthor.firstName }}</span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <label class="col-sm-2">Source</label>
                  <span class="col-sm-10">{{document.publication}} <template v-if="document.pubDate">, {{document.pubDate | moment('Y')}}</template></span>
                </div>

                <div class="col-sm-12" v-if="document.added">
                  <label class="col-sm-2">Added to project</label>
                  <span class="col-sm-10" v-if="document.added && document.added.date">{{document.added.date | moment('LL')}}</span>
                  <span v-else class="col-sm-10">{{document.added | moment('LL')}}</span>
                </div>

                <div class="col-sm-12">
                  <label class="col-sm-2" style="">Abstract</label>
                  <div style="" class="col-sm-10">
                    <div v-html="document.abstract"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="clearfix">
          <div style="margin-left:15px;margin-top: 15px">
            <label>information</label>
          </div>

          <div class="col-xs-10 col-xs-offset-2">
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 15px" v-if="companiesSelected.length !== 0 && displayExpertsCompanies === true">
      <h4>Companies</h4>

      <div style="margin-left: 15px">
        <div v-for="(company, key) in companiesSelected" :key="key" class="border-top" style="padding: 15px 0">
          <div class="text-info" style="font-size: 18px">{{company.lastName}} {{company.firstName}}</div>

          <div class="clearfix">
            <div style="margin-left:15px;margin-top: 15px">
              <label>information</label>
            </div>

            <div class="col-xs-10 col-xs-offset-2">
              <div style="margin-left: 25px">

                <div class="row">
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Status</label>
                      <span class="col-xs-6" v-if="company.affiliation.status_str">{{company.affiliation.status_str}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>

                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Country</label>
                      <span class="col-xs-6" v-if="company.affiliation.country">{{company.affiliation.country}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">City</label>
                      <span class="col-xs-6" v-if="company.affiliation.city">{{company.affiliation.city}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Incorp Date</label>
                      <span class="col-xs-6" v-if="company.affiliation.incorporation_date">{{company.affiliation.incorporation_date}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Turnover</label>
                      <span class="col-xs-6" v-if="company.affiliation.turnover">{{Math.round(company.affiliation.turnover) }} K €</span>
                      <span class="col-xs-6" v-else>n.a.</span>

                    </div>
                  </div>
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Nb Employees</label>
                      <span class="col-xs-6" v-if="company.affiliation.nb_employees">{{company.affiliation.nb_employees}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Category</label>
                      <span class="col-xs-6" v-if="company.affiliation.category">{{company.affiliation.category}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Website</label>
                      <span class="col-xs-6" v-if="company.affiliation.website"><a :href="company.affiliation.website" target="_blank">{{company.affiliation.website}}</a></span>
                      <span class="col-xs-6" v-else-if="company.affiliation.url"><a :href="company.affiliation.url" target="_blank">{{company.affiliation.url}}</a></span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                  <div class="col-xs-4">
                    <div class="row">
                      <label class="col-xs-6">Nb Patents</label>
                      <span class="col-xs-6" v-if="company.affiliation.nb_patents">{{company.affiliation.nb_patents}}</span>
                      <span class="col-xs-6" v-else>n.a.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix">

            <div style="margin-left:15px;margin-top: 15px">
              <label>Description</label>
            </div>

            <div class="col-xs-10 col-xs-offset-2">
              <div style="margin-left: 25px">
                <span v-if="company.affiliation.overview || company.affiliation.trade_description">{{company.affiliation.overview}}; {{company.affiliation.trade_description}}</span>
                <span v-else> No description available</span>
              </div>
            </div>
          </div>

          <div class="clearfix">

            <div style="margin-left:15px;margin-top: 15px">
              <label>Documents</label>
            </div>
            <div v-if="company.docs.length !== 0" v-for="(document, documentKey) in company.docs" :key="documentKey" class="row" style="margin-left:15px;margin-top: 15px">
              <div class="col-sm-12">
                <label class="col-sm-2">Title</label>
                <span class="col-sm-10" style="font-weight: bold" v-html="document.title"></span>
              </div>
              <div class="col-sm-12">
                <label class="col-sm-2">Source</label>
                <span class="col-sm-10">{{document.publication}} <template v-if="document.pubDate">, {{document.pubDate | moment('Y')}}</template></span>
              </div>

              <div class="col-sm-12" v-if="document.added">
                <label class="col-sm-2">Added to project</label>
                <span class="col-sm-10" v-if="document.added && document.added.date">{{document.added.date | moment('LL')}}</span>
                <span v-else class="col-sm-10">{{document.added | moment('LL')}}</span>
              </div>

              <div class="col-sm-12">
                <label class="col-sm-2" style="">Abstract</label>
                <div style="" class="col-sm-10">
                  <div v-html="document.abstract"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.coAuthors-divider + .coAuthors-divider:before {
  content: ", ";
}
</style>
<script>

import BiblioGoJS from '../biblio/BiblioGoJs'
import BiblioTree from '../biblio/BiblioTree'
import {sortByDepth, getBibliography, getAiChat} from '../../assets/scripts/biblio'

export default {
  components: {BiblioTree, BiblioGoJS},
  name: 'ListReport',
  props: {
    listId: {
      require: true
    },
    displayExpertsCompanies: {
      default: false
    },
    displayBiblioContent: {
      default: false
    },
    displayBiblioPreview: {
      default: false
    }
  },
  data () {
    return {
      list: null,
      authorsSelected: [],
      companiesSelected: [],
      biblioNodes: {}
    }
  },
  watch: {
    list: function (val) {
      if (val !== null) {
        setTimeout(() => {
          this.generateImage()
          this.$emit('resourcesLoaded', this.listId)
        }, 1000)
      }
    }
  },
  methods: {
    generateImage: function () {
      if (this.displayBiblioPreview === true && typeof this.$refs.biblio !== 'undefined') {
        let svg = this.$refs.biblio.getSvg()

        if (svg !== null) {
          this.$refs.biblioImg.src = svg
        }
      }
    },
    getImage: function () {
      if (this.displayBiblioPreview === true && typeof this.$refs.biblioImg !== 'undefined') {
        return this.$refs.biblioImg.src
      }
      return null
    }
  },
  mounted () {
  },
  beforeMount () {
    this.axios.get('list/' + this.listId + '?relations={biblio,companyAuthors}').then((response) => {
      this.list = response.data
      if (typeof response.data.company_authors !== 'undefined') {
        this.authorsSelected = response.data.company_authors.authors_selected
        this.companiesSelected = response.data.company_authors.companies_selected
        this.biblioNodes = sortByDepth(this.list.biblio[0].content)
        this.bibliography = getBibliography(this.list.biblio[0].content)
        this.aichat = getAiChat(this.list.biblio[0].content)
      }
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/ListIdexlab/Report.vue